import { render, staticRenderFns } from "./TaskEditModal.vue?vue&type=template&id=51e590ff&"
import script from "./TaskEditModal.vue?vue&type=script&lang=ts&"
export * from "./TaskEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports